import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SwUpdate} from '@angular/service-worker';
import {PrivacySnackbarComponent} from '../../components/privacy-snackbar/privacy-snackbar.component';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private swUpdate: SwUpdate, private snackbar: MatSnackBar) {
    if ('serviceWorker' in navigator && environment.production) {
      this.swUpdate.checkForUpdate();
    }
  }

  public init() {
    this.setupSnackBar();
    this.setupSwUpdate();
  }

  private setupSwUpdate() {
    this.swUpdate.available.subscribe(evt => {
      const snack = this.snackbar.open('Update Available', 'Reload', {duration: 30000});
      snack.onAction()
        .subscribe(() => {
          window.location.reload();
        });
    });
  }

  private setupSnackBar() {
    this.snackbar.openFromComponent(PrivacySnackbarComponent, {duration: 9000, verticalPosition: 'top'});
  }
}
